import { getAvatar } from '$tablet-app/src/app/avatars/functions/getAvatar';
import PegasusAvatar from '$tablet-app/src/app/components/Pegasus/PegasusAvatar';
import { useGetStateVariable } from '$tablet-app/src/app/state_variables';
import { StateVariableNames } from '$tablet-app/src/app/state_variables/state_variable_names';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { spacing } from '@akin-home/theme';
import React from 'react';
import { Image, View, StyleSheet } from 'react-native';
import { colors } from 'react-native-elements';

interface Props {
  mic_active?: boolean;

  onRequestClose?: () => any;
}

const ChatScreenHeader = (props: Props) => {
  const { mic_active = false, onRequestClose } = props;

  const { data: avatar_data } = useGetStateVariable(StateVariableNames.AVATAR);
  const avatar_asset = getAvatar(avatar_data);

  return (
    <View style={styles.container}>
      <View style={styles.imageContainer}>
        {avatar_asset ? (
          <Image style={styles.image} source={avatar_asset} />
        ) : (
          <PegasusAvatar noEvents size="small" />
        )}
      </View>

      <View style={styles.textContainer}>
        <View style={styles.titleText}>
          <Text variant="h3" bold>
            Hey Pixi
          </Text>
        </View>

        <Text
          variant="p2"
          italic
          color={!mic_active ? 'transparent' : undefined}
          style={styles.statusText}
        >
          Listening
        </Text>
      </View>

      <Button
        style={styles.closeButton}
        size="large"
        icon="times"
        variant="secondary"
        onPress={onRequestClose}
      />
    </View>
  );
};

export default ChatScreenHeader;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 100,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[2],
    paddingHorizontal: spacing[2],
    borderBottomWidth: 1,
    borderBottomColor: colors.divider,
  },
  imageContainer: {
    height: '100%',
    aspectRatio: 1,
  },
  image: {
    width: '100%',
    height: '100%',
  },
  textContainer: {
    flex: 1,
    alignSelf: 'stretch',
  },
  titleText: {
    flex: 2,
    justifyContent: 'flex-end',
  },
  statusText: {
    flex: 1,
  },
  closeButton: {
    marginLeft: 'auto',
  },
});
